import { useQuery } from 'react-query';

import api from '@root/api';

const query = ['bulkGenerations', {}];

export default function useBulkGenerations() {
  return useQuery(query, () => api.bulkGeneration.list(), { refetchOnMount: 'always' });
}
